import { IS_PRODUCTION, VK_PIXEL_COUNTER_ID } from "../env-management"
import { isBrowser } from "../infrastructure/ssg-utils"

const queue: Goal[] = isBrowser() ? window._tmr || (window._tmr = []) : []

interface Goal {
    type: "reachGoal"
    id: number
    goal: string
}

declare global {
    interface Window {
        _tmr: Goal[]
    }
}

export function tmrSendHitGoal(goal?: string) {
    if (IS_PRODUCTION && VK_PIXEL_COUNTER_ID && goal) {
        queue.push({
            type: "reachGoal",
            id: VK_PIXEL_COUNTER_ID,
            goal,
        })
    } else {
        console.log(
            `_tmr('${VK_PIXEL_COUNTER_ID ?? "<VK_PIXEL_COUNTER_ID>"}', "reachGoal", ${goal || ""}})`
        )
    }
}

tmrSendHitGoal.filter = (id?: string) => {
    if (!id) return
    return ["after_successful_booking", "session_time_selected", "psychologists_loaded"].includes(
        id
    )
}
